export enum EnumStatusData {
  draft = 'draft',
  active = 'active',
  inactive = 'inactive',
  posted = 'posted',
  obsolete = 'obsolete',
  closed = 'closed',
  cancel = 'cancel',
  in_process = 'in_process',
  done = 'done',
  waiting = 'waiting',
  pending = 'pending',
}

export enum EnumColorStatusData {
  draft = 'draft',
  active = 'success',
  inactive = 'error',
  in_process = 'blue',
  closed = 'volcano',
  cancel = 'red',
  pending = 'warning',
  waiting = 'warning',
  done = 'success',
}
export interface BaseEntity {
  id?: string;
  [key: string]: any;
}
